// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2UJJ8","rootSmall":"AddTileButton_rootSmall__2FTiW"};